const isObject = (value) => value !== null && typeof value === "object";

export const getResultPayload = (response) => {
    if (!isObject(response)) {
        return {};
    }

    if (isObject(response.data) && (
        response.data.code !== undefined ||
        response.data.success !== undefined ||
        response.data.message !== undefined
    )) {
        return response.data;
    }

    return response;
};

export const getResultData = (response) => {
    const payload = getResultPayload(response);
    return payload.data;
};

export const isResultSuccess = (response) => {
    const payload = getResultPayload(response);
    return payload.code === 200 && payload.success !== false;
};

export const getResultMessage = (response, fallback = "操作失败，请稍后重试") => {
    const payload = getResultPayload(response);
    const errorPayload = response && response.response
        ? getResultPayload(response.response)
        : null;

    return (errorPayload && errorPayload.message) || payload.message || fallback;
};

export const getResultError = (error, fallback) => {
    const resultError = new Error(getResultMessage(error, fallback));
    resultError.code = getResultPayload(error && error.response ? error.response : error).code;
    resultError.response = error && error.response;
    return resultError;
};

export const unwrapResult = (response, fallback) => {
    if (!isResultSuccess(response)) {
        throw getResultError(response, fallback);
    }
    return getResultData(response);
};

export const asList = (response) => {
    const data = getResultData(response);
    return Array.isArray(data) ? data : [];
};

export default {
    asList,
    getResultData,
    getResultError,
    getResultMessage,
    getResultPayload,
    isResultSuccess,
    unwrapResult,
};
